import { BsArrowRight } from "react-icons/bs"
import { logEvent } from "../utils/analytics";
import { useNavigate } from "react-router-dom";

const MagPin = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-map-pin-icon lucide-map-pin"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" /><circle cx="12" cy="10" r="3" /></svg>
const People = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-users-round-icon lucide-users-round"><path d="M18 21a8 8 0 0 0-16 0" /><circle cx="10" cy="8" r="5" /><path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" /></svg>
const Vote = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-package-check-icon lucide-package-check"><path d="m16 16 2 2 4-4" /><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14" /><path d="m7.5 4.27 9 5.15" /><polyline points="3.29 7 12 12 20.71 7" /><line x1="12" x2="12" y1="22" y2="12" /></svg>
const Help = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-circle-question-mark-icon lucide-circle-question-mark"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></svg>

const About = () => {

    const navigate = useNavigate();
    const onFeatureClick = (feature) => {

        logEvent('About', 'Clicked feature card', feature.title)

        if (feature.target) {
            document.querySelector(feature.target)?.scrollIntoView({ behaviour: 'smooth', block: 'center' });
        }
        navigate(feature.link || feature.target)
    }

    const features = [
        {
            title: 'Who to vote for',
            description: 'Discover candidates running in your area and learn more about them',
            icon: <People />,
            cta: 'Explore candidates',
            link: '/results'
        },
        {
            title: 'Where to vote',
            description: "Find out where you're registered to vote with our polling unit locator",
            icon: <MagPin />,
            cta: 'Find your unit',
            link: '/results?tab=where-to-vote'
        },
        {
            title: 'How to vote',
            description: "Be prepared. Get voting instructions and guidelines for election day",
            icon: <Vote />,
            cta: 'Learn more',
            target: '#how-to-vote'
        },
        {
            title: 'Why should I vote?',
            description: "Understand the election process and get updates on other important information.",
            icon: <Help />,
            cta: 'Read more',
            target: '#why-should-i-vote'
        }
    ]
    return (

        <div className="flex flex-col gap-6 px-7 py-9 rounded-t-2xl shadow-[0_-1px_4px_#dddddd]">
            <div className="flex flex-col gap-4">
                <h1
                    className="text-neutral-700 tracking-light text-[24px] font-bold leading-tight @[480px]:text-4xl @[480px]:font-black @[480px]:tracking-[-0.033em] max-w-[720px]"
                >
                    about HelpMeVote
                </h1>
                <p className="text-base font-normal leading-normal max-w-[720px]">
                    HelpMeVote is a non-partisan platform dedicated to providing accurate and up-to-date information on candidates and voting locations for the upcoming Nigerian election. Our goal is to help Nigerian citizens exercise their right to vote and make informed decisions. We strive to be a reliable source of information and encourage civic engagement.
                </p>
            </div>
            <div className="grid grid-cols-2 gap-3">
                {features.map((feature) => <button key={feature.title} onClick={() => onFeatureClick(feature)} className="group/feature text-left flex flex-1 gap-1 rounded-lg border border-gray-200 px-4 pt-4 pb-3 flex-col bg-white">
                    <div className="py-0.5 text-emerald-400">
                        {feature.icon}
                    </div>
                    <div className="flex flex-col gap-1 mb-2">
                        <h2 className="text-base font-bold leading-tight">{feature.title}</h2>
                        <p className="text-neutral-700 text-sm font-normal leading-normal">{feature.description}</p>
                    </div>

                    <span className="mt-auto inline-flex group-hover/feature:gap-2 group-hover/feature:text-neutral-900 transition-all items-center gap-1 text-sm underline text-neutral-500">
                        {feature.cta}
                        <BsArrowRight className="h-3 w-3" />
                    </span>
                </button>)}
            </div>
            <p className="italic text-sm text-gray-700">
                The data on HelpMeVote.ng is sourced from various providers. If any data is incorrect please share it with us at <a className="underline" href="mailto:nghelpmevote@gmail.com">nghelpmevote@gmail.com</a>
            </p>
        </div>
    )
}

export default About;
